import React from "react";

/**
 * Surfaces crawl health as a grid of issue counts over the most recent
 * crawl snapshot. Each cell colour-coded by severity relative to the
 * total pages crawled.
 */
export default function CrawlIssuesCard({ crawl }) {
  if (!crawl || !crawl.pages_crawled) {
    return <div className="empty">No site crawl yet. Run the crawler collector.</div>;
  }
  const total = crawl.pages_crawled;
  const issues = [
    { label: "Missing meta description", count: crawl.missing_meta_description },
    { label: "Thin content (<300 words)", count: crawl.thin_content_pages },
    { label: "4xx/5xx errors", count: crawl.error_pages, severe: true },
    { label: "Not indexable", count: crawl.not_indexable, severe: true },
    { label: "Pages missing alt text", count: crawl.pages_missing_alt },
  ];
  return (
    <>
      <div className="subtle" style={{ marginBottom: 10 }}>
        {total} pages crawled in latest snapshot
      </div>
      <div className="crawl-grid">
        {issues.map((i) => (
          <div
            key={i.label}
            className={`crawl-cell ${severityClass(i.count, total, i.severe)}`}
          >
            <div className="crawl-count">{i.count}</div>
            <div className="crawl-label">{i.label}</div>
            <div className="crawl-pct subtle">
              {total ? `${Math.round((i.count / total) * 100)}%` : ""}
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

function severityClass(count, total, severe) {
  if (count === 0) return "good";
  const pct = count / total;
  if (severe && count > 0) return "bad";
  if (pct > 0.3) return "bad";
  if (pct > 0.1) return "warn";
  return "good";
}
